<template>
  <div class="content" id="targets">
    <section :class="params.category" :key="params.category">
      <form @submit.prevent class="targetsform">
      <table>
        <thead>
          <tr><th>&nbsp;</th><th>{{params.category}}: <span class="fromto">{{params.from}} &rarr; {{params.to}}</span></th><th>&nbsp;</th></tr>
        </thead>
      <tbody>
        <tr v-for="(target, index) in categoryTargets" :key="params.category+'_'+ target.id+'_'+index">
          <td><input type="hidden" :name="params.category+'_id_'+index" v-model="target.id"><input type="checkbox" :name="'done_'+index" value="Y" v-model="target.done"></td>
          <td><input type="text" :id="'description_'+index" v-model="target.description"></td>
          <td><input type="number" :id="'priority_'+index" min="0" max="100" step="1" v-model.number="target.priority"></td>
        </tr>
        <tr v-if="categoryTargets.length==0">
          <td colspan="3">No targets found</td>
        </tr>
      </tbody>
      </table>
      <p v-if="isEditable"><button class="btnsave" @click="saveTargets(params.category,$event)">Save</button><span class="onemore" @click="addNewTarget(params.category,$event)">+</span></p>
      <error-message :errortype="error.type">{{error.message}}</error-message>
      </form>
    </section>

  </div>
</template>
<script>
import ErrorMessage from '@/components/ErrorMessage'
import dateHelper from '@/helpers/dateHelper'
import {mapActions} from 'vuex'
export default {
  components:{
    ErrorMessage,
  },

  data(){
    return{
      categoryTargets:[],
      error:{},
      params: this.$store.state.targetStore.currentCategoryTargets,
    }
  },
  computed:{
    isEditable(){
      const todayDate=dateHelper.getDisplayDate()
      console.log('Today date:', todayDate)
      return todayDate <= this.params['to'];
    },
  },
  methods:{
    ...mapActions('targetStore', ['fetchCurrentCategoryTargets', 'saveUploadTargets']),

    addNewTarget(){
      const priority=this.categoryTargets.length;
      this.categoryTargets.push({id: dateHelper.getUniqueID(), description:'', done: false, priority});
    },
    saveTargets(category){
      console.log('Request to save', category, 'targets')
      const targets=this.categoryTargets.filter(item => item.description.trim()!='');
      const payload={
        ...this.params,
        targets,
      };

      this.saveUploadTargets(payload, {rootStore:true}).then(()=>{
      }).catch(error =>{
        console.log(error)
      })
    },

    fetchCategoryTargets(){
      const payload={
        category:this.params['category'], 
        from: this.params['from'], 
        to: this.params['to'],
      }
      console.log('target category payload:', payload)
      this.fetchCurrentCategoryTargets(payload, {rootStore:true})
      .then(() => {
        const targets=this.$store.state.targetStore.currentCategoryTargets['targets'];
        if(targets && targets.length>0){
          this.categoryTargets=targets;
        }
      })
      .catch(error =>{
        this.setErrorMessage(error.message, 'error')
      })
    },

    setErrorMessage(message, type='alert'){
      this.error={message, type}
    },
  },
  
  created(){
    this.error={message:'', type:'alert'},
    this.target={from:'', to:''}
    this.fetchCategoryTargets()
  }
  
}
</script>